import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, updateDoc, doc, deleteDoc, Timestamp, getDoc } from 'firebase/firestore';
import EditUser from './EditUser';
import ProviderDetails from './ProviderDetails';
import FeedbackList from './FeedbackList';

// CSV download helpers
function downloadCSV(data, filename) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));
  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return typeof val === 'string' ? `"${val.replace(/"/g, '""')}"` : val;
    });
    csvRows.push(values.join(','));
  }
  const csvString = csvRows.join('\n');
  const blob = new Blob([csvString], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

async function exportCollectionAsCSV(collectionName, db) {
  const snapshot = await getDocs(collection(db, collectionName));
  const data = [];
  snapshot.forEach(doc => data.push({ id: doc.id, ...doc.data() }));
  if (data.length > 0) {
    downloadCSV(data, `${collectionName}.csv`);
  } else {
    alert('No data to export!');
  }
}

export default function Dashboard() {
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [viewProvider, setViewProvider] = useState(null);
  const [withdrawals, setWithdrawals] = useState([]);
  const [editingValidity, setEditingValidity] = useState(null);

  const handleValidityUpdate = async (userId, dateString) => {
    const date = new Date(dateString);
    await updateDoc(doc(db, 'users', userId), { validity: Timestamp.fromDate(date) });
    setEditingValidity(null);
    fetchUsers();
  };

  const fetchUsers = async () => {
    const querySnapshot = await getDocs(collection(db, 'users'));
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    setUsers(data);
  };


  const fetchWithdrawals = async () => {
    // const querySnapshot = await getDocs(collection(db, 'withdrawal_requests'));
    // const data = [];
    // querySnapshot.forEach(async (doc) => {
    //   console.log(doc.data(), 'sdkfsh')

    //   const data = doc.data();
    //   const providerId = data.providerId;
    //   console.log(doc.data(), 'sdkfsh')

    //   let userName = "Unknown";

    //   if (providerId) {
    //     const userRef = doc(db, "users", providerId);
    //     const userSnap = await getDoc(userRef);

    //     if (userSnap.exists()) {
    //       const userData = userSnap.data();
    //       userName = userData.name || "Unnamed User"; // adjust field name as needed
    //     }
    //   }
    //   data.push({ id: doc.id, ...doc.data(), userName });
    // });

    // setWithdrawals(data);

    const querySnapshot = await getDocs(collection(db, 'withdrawal_requests'));

    const withdrawals = await Promise.all(
      querySnapshot.docs.map(async (docSnap) => {
        const withdrawalData = docSnap.data();
        const providerId = withdrawalData.providerId;
        let userName = "Unknown";
        if (providerId) {
          const userRef = doc(db, "users", providerId);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const userData = userSnap.data();
            userName = userData.name || "Unnamed User"; // adjust as needed
          }
        }
        console.log('userName', userName)
        return {
          id: docSnap.id,
          ...withdrawalData,
          userName,
        };
      })
    );

    setWithdrawals(withdrawals);

  };

  useEffect(() => {
    fetchUsers();
    fetchWithdrawals();
  }, []);

  const handleApprove = async (id) => {
    await updateDoc(doc(db, 'users', id), { approved: true });
    fetchUsers();
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, 'users', id));
    fetchUsers();
  };

  const handleMakePayment = async (id, status) => {
    await updateDoc(doc(db, 'withdrawal_requests', id), {
      status: status,
      processedAt: Timestamp.now()

    });
    // fetchWithdrawals();

    // const requestRef = db.collection("withdrawal_requests").doc(id);
    // await requestRef.update({
    //   status: status,
    //   processedAt: Timestamp.now(),
    // });
    fetchWithdrawals();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Dashboard</h2>
      <div style={{ margin: '20px 0' }}>
        <button onClick={() => exportCollectionAsCSV('users', db)}>Download Users as Excel</button>
        <button onClick={() => exportCollectionAsCSV('feedback', db)} style={{ marginLeft: 10 }}>Download Feedback as Excel</button>
      </div>
      {editUser && (
        <EditUser user={editUser} onClose={() => { setEditUser(null); fetchUsers(); }} />
      )}
      {viewProvider && (
        <ProviderDetails providerId={viewProvider} onClose={() => setViewProvider(null)} />
      )}

      <h3>Pending Approvals</h3>
      <table border="1" cellPadding="8" style={{ width: '100%', marginTop: 20 }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Category</th>
            <th>Payment Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.filter(u => u.category !== 'enduser' && !u.approved).map(u => (
            <tr key={u.id}>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.mobile}</td>
              <td>{u.category}</td>
              <td>{u.paid? "Paid":"Not Paid" }</td>
              <td>
                <button onClick={() => handleApprove(u.id)}>Approve</button>
                <button onClick={() => handleDelete(u.id)} style={{ marginLeft: 8 }}>Delete</button>
                <button onClick={() => setViewProvider(u.id)} style={{ marginLeft: 8 }}>View</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Pending Withdrawals</h3>
      <table border="1" cellPadding="8" style={{ width: '100%', marginTop: 20 }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Amount</th>
            {/* <th>Date  </th> */}
            <th>Status  </th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {withdrawals.map(u => (
            <tr key={u.id}>
              <td>{u.userName}</td>
              <td>{u.amount}</td>
              {/* <td>{u.requestedAt}</td> */}
              <td>{u.status}</td>
              <td>
                <button onClick={() => handleMakePayment(u.id, "approve")}>Approve</button>
                <button onClick={() => handleMakePayment(u.id, "reject")} style={{ marginLeft: 8 }}>Delete</button>
                <button onClick={() => setViewProvider(u.id)} style={{ marginLeft: 8 }}>View</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>All Users & Providers</h3>
      <table border="1" cellPadding="8" style={{ width: '100%', marginTop: 20 }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Category</th>
            <th>Approved</th>
            <th>Validity</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.mobile}</td>
              <td>{u.category}</td>
              <td>{u.approved ? 'Yes' : 'No'}</td>
              <td>
                {editingValidity === u.id ? (
                  <input
                    type="date"
                    defaultValue={u.validity?.toDate ? u.validity.toDate().toISOString().split('T')[0] : ''}
                    onBlur={(e) => {
                      if (e.target.value) handleValidityUpdate(u.id, e.target.value);
                      else setEditingValidity(null);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && e.target.value) handleValidityUpdate(u.id, e.target.value);
                      if (e.key === 'Escape') setEditingValidity(null);
                    }}
                    autoFocus
                  />
                ) : (
                  <span onClick={() => setEditingValidity(u.id)} style={{ cursor: 'pointer' }}>
                    {u.validity?.toDate ? u.validity.toDate().toLocaleDateString('en-GB') : 'Set date'}
                  </span>
                )}
              </td>
              <td>
                <button onClick={() => setEditUser(u)}>Edit</button>
                <button onClick={() => handleDelete(u.id)} style={{ marginLeft: 8 }}>Delete</button>
                {u.category !== 'enduser' && <button onClick={() => setViewProvider(u.id)} style={{ marginLeft: 8 }}>View</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>All Feedback</h3>
      <FeedbackList />
    </div>
  );
}